import axios from "axios";
import { Url_Base } from "./Url.service";

const AuthService = {
  login: async (values) => {
    try {
      values.usuario_id = 1;
      values.promotora_id = 1;
      const response = await axios.post(
        `${Url_Base}api/login`,
        values
      );
      return response;
    } catch (error) {
      throw error;
    }
  },
  register: async (values) => {
    try {
      const response = await axios.post(
        `${Url_Base}api/register`,
        values
      );
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export default AuthService;
